import { HttpResponse } from "@/app/api/request"
import { IotGateModel } from "@/app/models/iot-gate.model"
import { api } from "@/app/api"
import { IotGateModelWithSpamPrevention } from "@/app/models/iot-gate-model-with-spam-protection.model"
import { Ref, ref } from "@vue/composition-api"
import { findMainGate } from "@/app/utils/gate.utils"

export const useIoTControl = () => {
  // Gates per facility
  const gates: Ref<IotGateModelWithSpamPrevention[]> = ref([])

  // Status is composable dependant
  const isOpenGatePending = ref(false)

  async function fetchGatesWithSpamPrevention(
    facilityId: string,
  ): Promise<Ref<IotGateModelWithSpamPrevention[]>> {
    // Reset the gates
    gates.value = []

    const response: HttpResponse<IotGateModel[]> = await api.findAllGatesForFacility(
      facilityId,
    )

    if (response.wasSuccessful && response.data) {
      response.data.forEach(iotGate => {
        const gateWithSpamPrevention: IotGateModelWithSpamPrevention = {
          ...iotGate,
          spamPrevention: false,
          opening: false,
        }
        gates.value.push(gateWithSpamPrevention)
      })
    }

    return gates
  }

  async function openGate(bookingId: string, iotDeviceGateId: number) {
    isOpenGatePending.value = true
    const response = await api.openGateByBooking(bookingId, iotDeviceGateId)
    isOpenGatePending.value = false
    return response
  }

  async function openMainGate(bookingId: string) {
    const mainGate = findMainGate(gates.value)
    if (mainGate) {
      await openGate(bookingId, mainGate.iotDeviceGateId)
    }
  }

  return {
    // Variables
    gates,
    isOpenGatePending,

    // Methods
    fetchGatesWithSpamPrevention,
    openGate,
    openMainGate,
  }
}
